import React , {Component} from "react";
// import { configuration } from "../appConfig";
import { Link } from "react-router-dom";
import Axios from 'axios';
import { configuration } from "../../appConfig";
import Spinner from "../../spinner";



import {
    Card,
    CardHeader,
    Col,
    FormGroup,
    Input,
    Label,
    Row,
  } from "reactstrap";

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

export default class CreateVinRecord extends Component {
    state = {
        // selectedFile: "",
        regNo: "",
        vin: "",
        make: "",
        model: "",
        color: "",
        estimateId: "",
        client: "",
        InsurenceName: "",
        insurenceLogo: "Adi.png",
        makeModel: [],
        Models: [],
        email:"",
          clients: [
            {
              SN: "1",
              Logo: "Adi.png",
              Notes: "Thank you",
              Email: "sa@pt3d.de",
              Name: "Adi",
            },
            {
              SN: "2",
              Logo: "AIG.png",
              Notes: "Thank you",
              Email: "sa@pt3d.de",
              Name: "AIG",
            },
          ],
          
 
    }
    getMakeModel = async () => {
        await Axios.get("makeModel.json").then((r) => {
          this.setState({ makeModel: r.data });
        });
      };
      componentDidMount() {
        this.getInsurenceClients();
        const client = localStorage.getItem("client");
        this.setState({ client });
    
        if (this.props.location.state) {
          this.filEditForm();
        } else {
          this.getMakeModel();
        }
      }
      getInsurenceClients = () => {
        const partnerId = localStorage.getItem("partnerId");
        ///Axios.get(`insurenceClients/${partnerId}/insurenceList.json`).then(res=>{
        const url = configuration.getInsurenceClients + "?partnerId=" + partnerId;
        Axios.get(url).then((res) => {
    
          if (res.data) {
            this.setState({
              clients: res.data,
              InsurenceName: res.data[0].Name,
              insurenceLogo: res.data[0].Logo,
            });
          }
        });
      };
    handleChange = (e) => {
        this.setState({
          [e.target.name]: e.target.value,
        });
      };
    handleSubmit = () => {
      const partnerId = localStorage.getItem("partnerId");
      const {
        vin,
        make,
        model,
        color,
        estimateId,
        regNo,
        InsurenceName,
        email,
      } = this.state;
      if (this.state.vin) {
        // const url = `${configuration}/api_v2/PostSingleVINRecord.php?vin=${vin}&partnerId=${partnerId}&regNo=${regNo}&make=${make}&model=${model}&color=${color}&estimateId=${estimateId}`;
        let data = {
          "vin": vin,
          "model": model,
          "make": make,
          "regNo": regNo,
          "color": color,
          "orderId": estimateId,
          "insuranceClient": InsurenceName,
          "email": email,
          "partnerId": partnerId,
        
        };
        data = JSON.stringify(data);
        Axios.post(configuration.postSingleVINRecord, data).then(
          (res) => {
            if (res.hasOwnProperty('data'))  {
              if (res.data.hasOwnProperty('status'))  {
                if(res.data.status == "true"){
                  alert(res.data.message);
                  this.props.history.push("/scanlist");
                } else {
                  alert("Internal server error please try again");
                }
              }
              else {
                alert("Internal Server Error. Please try again later.");
              }
            }
            else {
              alert("Internal Server Error. Please try again later.");
            }
          }
        ).catch((err) => {
          alert("Internal Server Error. Please try again later.");
        });
      }
    };
    render(){
        const { vin, regNo } = this.state;
        const partnerId = localStorage.getItem("partnerId");

        return(
            <div className="animated fadeIn">
            <div className="card">
              <Row>
                <Col md="12" sm="12">
                  <Card>
                    <CardHeader>
                      <small className="">Create VIN</small>
                    </CardHeader>
                    <div className="row vertical-align-middle align-items-center">
                      <Col md="4 ">
                        <Label>Vin No</Label>
                        <div className="input-group">
                          <input
                          type="text"
                            className="form-control"
                            // placeholder=""
                            onChange={this.handleChange}
                            value={vin}
                            name="vin"
                            required
                          />
                        
                        </div>
                      </Col>
                      <Col md="4 ">
                        <Label>Registration No.</Label>
                        <div className="input-group">
                          <input
                            className="form-control"
                            placeholder=""
                            onChange={this.handleChange}
                            value={regNo}
                            name="regNo"
                            required/>
                         
                        </div>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label>Order No</Label>
                          <Input
                            type="text"
                            id="city"
                            onChange={this.handleChange}
                            name="estimateId"
                            value={this.state.estimateId}
                            required
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label>Color</Label>
                          <div className="input-group">
                            <input
                              className="form-control"
                              type="text"
                              id="input2-group3"
                              name="color"
                              placeholder="Select Color"
                              disabled
                              onChange={this.handleChange}
                              value={this.state.color}
                              required
                            /> 
                            <div className="input-group-append dropdown">
                              <select
                                name="color"
                                className="form-control p-2"
                                onChange={this.handleChange}
                                value={this.state.color}
                              >
                                {[
                                  { title: "Select", value: "" },
                                  { title: "Black", value: "000" },
                                  {
                                    title: "DarkBlue",
                                    value: "0A0A46",
                                  },
                                  {
                                    title: "Brown",
                                    value: "460A0A",
                                  },
                                  {
                                    title: "DarkGreen",
                                    value: "182D0F",
                                  },
                                  { title: "Red", value: "960A0A" },
                                  {
                                    title: "DarkOrange",
                                    value: "B45000",
                                  },
                                  {
                                    title: "Green",
                                    value: "32AA32",
                                  },
                                  {
                                    title: "Orange",
                                    value: "F09600",
                                  },
                                  {
                                    title: "YellowOrange",
                                    value: "D4AF37",
                                  },
                                  {
                                    title: "YellowGreen",
                                    value: "C8C864",
                                  },
                                  { title: "Grey", value: "E1E1E1" },
                                  {
                                    title: "White",
                                    value: "FFFFFF",
                                  },
                                ].map((row, ind) => (
                                  <option key={ind}> {row.title}</option>
                                ))}
                              </select>
                            </div>
                           </div>
                        </FormGroup> 
                      </Col>
    
                      <Col md="4">
                        <FormGroup>
                          <Label>Make : {this.state.make} </Label>
                          {/* <Input
                            type="text"
                            id="city"
                            onChange={this.handleChange}
                            name="make"
                            value={this.state.make}
                          /> */}
    
                          <select
                            className="form-control"
                            placeholder="Make"
                            onChange={(e) => {
                              const Models = this.state.makeModel.filter((t) => {
                                return t.Make == e.target.value;
                              });
    
    
                              this.setState({
                                make: e.target.value,
                                Models: Models[0].Model,
                              });
                            }}
                            value={this.state.make}
                            name="make"
                            required
                          >
                            <option>-- Select--</option>
                            {this.state.makeModel.map((r, j) => (
                              <option key={j} value={r.Make}>
                                {r.Make}
                              </option>
                            ))}
                          </select>
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label>Model</Label>
                          <select
                            className="form-control"
                            placeholder="Model"
                            onChange={this.handleChange}
                            value={this.state.model}
                            name="model"
                            required
                          >
                            <option>--Select --</option>
                            {this.state.Models.length &&
                              this.state.Models.map((r, j) => (
                                <option key={j}>{r}</option>
                              ))}
                          </select>
    
                          {/* <Input
                            type="text"
                            id="city"
                            onChange={this.handleChange}
                            name="model"
                            value={this.state.model}
                          /> */}
                        </FormGroup>
                      </Col>
    
                      <Col md="4">
                        <FormGroup>
                          <Label>Email</Label>
                          <Input
                            type="text"
                            onChange={this.handleChange}
                            name="email"
                            value={this.state.email}
                            required
                          />
                        </FormGroup>
                      </Col>
                      {/* <Col md="4">
                        <FormGroup>
                          <Label>Notes</Label>
                          <Input
                            type="text"
                            onChange={this.handleChange}
                            name="comment"
                            value={this.state.comment}
                          />
                        </FormGroup>
                      </Col> */}
                      <Col md="2">
                    <FormGroup>
                      <Label htmlFor="postal-code">Insurance Client</Label>
                      <select
                        className="form-control"
                        placeholder="Insurance client"
                        onChange={this.handleChange}
                        //  defaultValue={this.state.InsurenceName}
                        value={this.state.InsurenceName}
                        name="InsurenceName"
                        required
                      >
                        {this.state.clients &&
                          this.state.clients.length &&
                          this.state.clients.map((r, i) => (
                            <option key={i}>{r.Name}</option>
                          ))}
                      </select>
                    </FormGroup>
                  </Col>
                  <Col md="2"></Col>
                  <Col md="2"></Col>
                      <Col md="2">
                        <FormGroup>
                          <img
                            width="100%"
                            alt={this.state.InsurenceName}
                            src={`${configuration.imagePath}/scanImages/${partnerId}/insurenceClients/${
                              this.state.insurenceLogo || "Adi.png"
                            }`}
                          />
                        </FormGroup>
                      </Col>
                    </div>
    
                    <div className="card-footer">
                      <button
                        className="btn btn-danger btn-lg pull-right"
                        onClick={this.handleSubmit}
                      >
                        Save VIN
                      </button>
                    </div>
                  </Card>
                </Col>
              </Row>
            </div>
          </div>
        );
    }
}